export const postdata = [
    {
      id : 1,
      img : "https://i.ytimg.com/vi/0v2mx-kchG0/sddefault.jpg",
      head : "Timeless Elegance: The Allure of Gold Jewelry",
      para : "Explore the enduring appeal of gold jewelry, its historical significance, and how it has stood the test of time in the ever-changing world of fashion. ",
      first : "Gold has held immense cultural and historical significance throughout civilizations. In ancient societies, gold was associated with the divine, often reserved for royalty and sacred artifacts. Its scarcity and unique properties made it a symbol of wealth and prestige, with civilizations like the Egyptians using it to craft elaborate jewelry for both the living and the deceased. ",
      detailimg : "http://placehold.it/1140x485",
      quots : "Gold has consistently been a symbol of prosperity and social status. Across various cultures, wearing gold jewelry has been a way to display one's affluence and success. Whether in the form of crowns, necklaces, or bracelets, gold has adorned kings and queens, showcasing power and opulence.",
      second : "Gold's enduring value extends beyond its ornamental use. Considered a reliable investment, gold has retained its worth over time, acting as a hedge against economic uncertainties. Its resistance to tarnish and corrosion ensures that gold jewelry remains beautiful and valuable for generations, creating a lasting legacy.In conclusion, the timeless elegance of gold jewelry goes beyond its surface beauty. It encompasses a rich history, cultural significance, and emotional connections, making it a symbol of enduring style and sophistication. As trends come and go, gold jewelry continues to shine, proving that its allure is truly timeless.",
      comments : [
        {
          id : 1,
          img : "http://placehold.it/75x75",
          name : "Admin",
          time : "April 10, 2016 | 11.25 am",
          replay : "Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque. Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque... "
        },
        {
          id : 2,
          img : "http://placehold.it/75x75",
          name : "Admin",
          time : "April 10, 2016 | 11.25 am",
          replay : "Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque. Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque... "
        },
        {
          id : 3,
          img : "http://placehold.it/75x75",
          name : "Admin",
          time : "April 10, 2016 | 11.25 am",
          replay : "Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque. Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque... "
        }
      ]
  
    },
    {
      id : 2,
      img : "https://www.caratlane.com/blog/wp-content/uploads/2023/10/1B-9.jpg",
      head : "Choosing the Perfect  Necklace: A Comprehensive Guide",
      para : "Provide tips and insights on selecting the right gold necklace based on different occasions, necklines, and personal styles. Include information on chain types, pendant options, and length considerations.",
      first : "Diamond necklaces are timeless pieces that add a touch of elegance to any outfit. However, selecting the right one can be a daunting task with the myriad of options available. This comprehensive guide aims to simplify the process, providing insights, tips, and considerations to help you choose the perfect gold necklace for every occasion.",
      detailimg : "http://placehold.it/1140x485",
      quots : "When it comes to selecting the perfect gold necklace, several factors come into play, ranging from occasion and neckline to personal style preferences. This comprehensive guide will provide you with valuable tips and insights to make an informed choice.      ",
      second : " Consider the Occasion: Everyday Wear:Opt for a simple and versatile gold chain for daily wear. A classic cable or link chain works well for a subtle and elegant look. Formal Events:Choose a more elaborate design with intricate details for special occasions. Consider a gold necklace with gemstone accents or a statement pendant. Evaluate Neckline and Neck Size: V-Neck or Plunging Neckline: Pair a V-neck with a pendant necklace to complement the neckline and create an elongating effect. Crew Neck or High Neckline: Opt for shorter necklaces like chokers or princess-length necklaces that sit just below the collarbone.Strapless or Off-the-Shoulder:Statement pieces or chunky gold chains can enhance the bare neckline and add drama.",
      comments : [
        {
          id : 1,
          img : "http://placehold.it/75x75",
          name : "Admin",
          time : "April 10, 2016 | 11.25 am",
          replay : "Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque. Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque... "
        },
        {
          id : 2,
          img : "http://placehold.it/75x75",
          name : "Admin",
          time : "April 10, 2016 | 11.25 am",
          replay : "Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque. Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque... "
        }
      ]
    },
    {
      id : 3,
      img : "https://assets.thehansindia.com/h-upload/2020/01/10/253136-gold0.jpg",
      head : "Trending Styles: Contemporary Gold Jewelry Designs",
      para : "Showcase and discuss the latest trends in gold jewelry, including modern designs, unique shapes, and how contemporary artists are redefining traditional gold pieces.",
      first : "In the dynamic world of fashion, contemporary gold jewelry designs have taken center stage, offering a fresh perspective on this timeless metal. This blog post will explore the hottest trends in gold jewelry, showcasing how designers are redefining traditional norms and pushing boundaries to create pieces that resonate with the modern aesthetic.",
      detailimg : "http://placehold.it/1140x485",
      quots : "In the ever-evolving world of fashion, contemporary gold jewelry designs are pushing boundaries, embracing innovation, and redefining traditional concepts. Let's delve into the latest trends, exploring modern aesthetics, unique shapes, and the ways in which artists are transforming the landscape of gold jewelry.",
      second : "Modern Geometric Shapes: Clean Lines and Angular Designs: Contemporary gold jewelry often features sleek geometric shapes, with designers incorporating clean lines and angular forms for a minimalist yet impactful look. Geometric Pendants and Earrings: Statement-making geometric pendants and earrings are gaining popularity. Shapes like squares, triangles, and hexagons add a modern edge to traditional gold pieces.",
      comments : [
        {
          id : 1,
          img : "http://placehold.it/75x75",
          name : "Admin",
          time : "April 10, 2016 | 11.25 am",
          replay : "Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque. Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque... "
        },
        {
          id : 2,
          img : "http://placehold.it/75x75",
          name : "Admin",
          time : "April 10, 2016 | 11.25 am",
          replay : "Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque. Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque... "
        }
      ]
    },
    {
      id : 4,
      img : "https://gemsofroyalty.com/wp-content/uploads/2023/06/cleaning-jewelry-at-home.jpg",
      head : "Caring for Your Gold Jewelry: Maintenance Tips and Tricks",
      para : "Offer a guide on how to clean and care for gold jewelry to keep it looking as radiant as the day it was purchased. Include information on storing, cleaning, and handling gold pieces. ",
      first : "Gold jewelry has been cherished for centuries, admired for its timeless beauty and enduring value. To ensure your treasured pieces retain their luster and brilliance, it's essential to adopt proper care and maintenance practices. This comprehensive guide will provide you with valuable tips and tricks to keep your gold jewelry looking as radiant as the day you acquired it.",
      detailimg : "http://placehold.it/1140x485",
      quots : "Gold jewelry, with its timeless elegance, deserves proper care to maintain its radiance and beauty over time. Follow these practical tips to ensure your gold pieces remain as stunning as the day you acquired them.",
      second : "Separate Jewelry Pieces: Store gold jewelry pieces separately to prevent scratching and tangling. Consider using individual pouches or a lined jewelry box with compartments. Avoid Moisture: Keep your gold jewelry away from moisture and humidity to prevent tarnishing. Store pieces in a dry environment to maintain their luster. Anti-Tarnish Strips: Include anti-tarnish strips in your jewelry storage to absorb pollutants that may cause tarnish. These strips help maintain the shine of your gold pieces.",
      comments : [
        {
          id : 1,
          img : "http://placehold.it/75x75",
          name : "Admin",
          time : "April 10, 2016 | 11.25 am",
          replay : "Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque. Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque... "
        },
        {
          id : 2,
          img : "http://placehold.it/75x75",
          name : "Admin",
          time : "April 10, 2016 | 11.25 am",
          replay : "Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque. Pharetra, erat sed fermentum feugiat, velit mauris egestas quam, ut aliquam massa nisl quis neque... "
        }
      ]
    }
];


export const featureddata = [
  {
    id:1,
    head: "FEATURED PRODUCTS",
    featureddata: [
      {
        parentId: 1, 
        id : 1,
        img: "https://catherinebest.com/cdn/shop/products/Bcf6057yw_201_1_400x.png?v=1649186882",
        heading: "Fe Diamond Daze Bracelet",
        para: "24k gold-plated recycled sterling silver",
        price: "from £66.67"
      },
      {
        parentId: 1, 
          id : 2,
          img: "https://catherinebest.com/cdn/shop/products/Bcf6057yw_201_1_400x.png?v=1649186882",
          heading: "Fe Diamond Daze Bracelet",
          para: "24k gold-plated recycled sterling silver",
          price: "from £66.67"
        },
        {
          parentId: 1, 
          id : 3,
          img: "https://catherinebest.com/cdn/shop/products/Bcf6057yw_201_1_400x.png?v=1649186882",
          heading: "Fe Diamond Daze Bracelet",
          para: "24k gold-plated recycled sterling silver",
          price: "from £66.67"
        },
        {
          parentId: 1, 
          id : 4,
          img: "https://catherinebest.com/cdn/shop/products/Bcf6057yw_201_1_400x.png?v=1649186882",
          heading: "Fe Diamond Daze Bracelet",
          para: "24k gold-plated recycled sterling silver",
          price: "from £66.67"
        },
        
    ]
  },
  {
    id:2,
    head: "BRIDAL JEWELLERY",
    featureddata: [
      {
        parentId: 2, 
        id : 1,
        img: "https://catherinebest.com/cdn/shop/products/Bcf6057yw_201_1_400x.png?v=1649186882",
        heading: "BR Diamond Daze Bracelet",
        para: "24k gold-plated recycled sterling silver",
        price: "from £66.67"
      },
      {
        parentId: 2,
          id : 2,
          img: "https://catherinebest.com/cdn/shop/products/Bcf6057yw_201_1_400x.png?v=1649186882",
          heading: "BR Diamond Daze Bracelet",
          para: "24k gold-plated recycled sterling silver",
          price: "from £66.67"
        },
        {
          parentId: 2,
          id : 3,
          img: "https://catherinebest.com/cdn/shop/products/Bcf6057yw_201_1_400x.png?v=1649186882",
          heading: "BR Diamond Daze Bracelet",
          para: "24k gold-plated recycled sterling silver",
          price: "from £66.67"
        },
        {
          parentId: 2,
          id : 4,
          img: "https://catherinebest.com/cdn/shop/products/Bcf6057yw_201_1_400x.png?v=1649186882",
          heading: "BR Diamond Daze Bracelet",
          para: "24k gold-plated recycled sterling silver",
          price: "from £66.67"
        },
    ]
  },
  {
    id:3,
    head: "FASHION JEWELLERY",
    featureddata: [
      {
        parentId: 3,
        id : 1,
        img: "https://catherinebest.com/cdn/shop/products/Bcf6057yw_201_1_400x.png?v=1649186882",
        heading: "FJ Diamond Daze Bracelet",
        para: "24k gold-plated recycled sterling silver",
        price: "from £66.67"
      },
      {
        parentId: 3,
          id : 2,
          img: "https://catherinebest.com/cdn/shop/products/Bcf6057yw_201_1_400x.png?v=1649186882",
          heading: "FJ Diamond Daze Bracelet",
          para: "24k gold-plated recycled sterling silver",
          price: "from £66.67"
        },
        {
          parentId: 3,
          id : 3,
          img: "https://catherinebest.com/cdn/shop/products/Bcf6057yw_201_1_400x.png?v=1649186882",
          heading: "FJ Diamond Daze Bracelet",
          para: "24k gold-plated recycled sterling silver",
          price: "from £66.67"
        },
        {
          parentId: 3,
          id : 4,
          img: "https://catherinebest.com/cdn/shop/products/Bcf6057yw_201_1_400x.png?v=1649186882",
          heading: "FJ Diamond Daze Bracelet",
          para: "24k gold-plated recycled sterling silver",
          price: "from £66.67"
        },
    ]
  }
];

export const dataTop = [
  // {
  //   id : 1,
  //   url:"https://bijouq.com/wp-content/uploads/2022/10/chokers-1-600x600.jpg",
  //   title : "BRACELETS"
  // },
  {
    id :2,
    url:"https://bijouq.com/wp-content/uploads/2022/10/home-rose-2-600x600.jpg",
    title : "EARRINGS"
  },
  {
    id : 3,
    url:"https://bijouq.com/wp-content/uploads/2022/10/IMG_3141-1-600x600.jpg",
    title : "RINGS"
  },
  {
    id : 4,
    url:"https://bijouq.com/wp-content/uploads/2022/07/50-600x600.jpg",
    title : "BANGLES"
  },
  {
    id : 5,
    url:"https://bijouq.com/wp-content/uploads/2022/10/IMG_0160-1-600x600.png",
    title : "PENDANTS"
  },
  {
    id : 6,
    url:"https://bijouq.com/wp-content/uploads/2022/10/IMG_0173e-1-600x600.png",
    title : "NECKLACES"
  },
  
] 

// export const jewellerydata = [
//   {
//     "category": "Necklaces",
//     "items": [
//       {
//         "id": 1,
//         "name": "Art Deco Coral Necklace",
//         "material": "Rose gold, Diamonds, Coral",
//         "img" : "/images/products/necklace/1.JPG",
//         "description": "Simple and elegant gold chain necklace."
//       },
//       {
//         "id": 2,
//         "name": "Art Deco Diamonds Necklace, L Model",
//         "material": "Silver",
//         "img" : "/images/products/necklace/2.JPG",
//         "description": "Graceful necklace featuring a pearl pendant on a silver chain."
//       },
//       {
//         "id": 3,
//         "name": "Art Deco Diamonds Necklace, L Model",
//         "material": "White Gold, Diamonds",
//         "img" : "/images/products/necklace/3.JPG",
//         "description": "Graceful necklace featuring a pearl pendant on a silver chain."
//       },
//       {
//         "id": 4,
//         "name": "Art Deco Diamonds Necklace, L Model",
//         "material": "White Gold, Diamonds, Green Stone",
//         "img" : "/images/products/necklace/4.JPG",
//         "description": "Graceful necklace featuring a pearl pendant on a silver chain."
//       },
//       {
//         "id": 5,
//         "name": "Art Deco Diamonds Necklace, L Model",
//         "material": "Yellow Gold, Diamonds, Green Stone",
//         "img" : "/images/products/necklace/5.JPG",
//         "description": "Graceful necklace featuring a pearl pendant on a silver chain."
//       },
//       {
//         "id": 6,
//         "name": "Art Deco Diamonds Necklace, L Model",
//         "material": "White Gold, Diamonds, Green Stone",
//         "img" : "/images/products/necklace/6.JPG",
//         "description": "Graceful necklace featuring a pearl pendant on a silver chain."
//       },
//       {
//         "id": 7,
//         "name": "Art Deco Malachite Necklace",
//         "material": "Rose gold, Diamonds, Malachite",
//        "img" : "/images/products/necklace/7.JPG",
//         "description": "Graceful necklace featuring a pearl pendant on a silver chain."
//       },
//       {
//         "id": 8,
//         "name": "Art Deco Turquoise Necklace",
//         "material": "White Gold, Diamonds, Turquoise",
//         "img" : "/images/products/necklace/8.JPG",
//         "description": "Graceful necklace featuring a pearl pendant on a silver chain."
//       },
//       {
//         "id": 9,
//         "name": "Art Deco Pink Coral Necklace, L Model",
//         "material": "White Gold, Diamonds, Green Stone",
//         "img" : "/images/products/necklace/9.JPG",
//         "description": "Graceful necklace featuring a pearl pendant on a silver chain."
//       },
//       {
//         "id": 10,
//         "name": "Classic Geomatrica Malachite Necklace, L Model",
//         "material": "Rose Gold, Diamonds, Malachite",
//         "img" : "/images/products/necklace/10.JPG",
//         "description": "Graceful necklace featuring a pearl pendant on a silver chain."
//       }
//     ]
//   },
//   {
//     "category": "Earrings",
//     "items": [
//       {
//         "id": 1,
//         "name": "Art Deco Coral Earrings",
//         "material": "Rose gold, Diamonds, Coral",
//         "img" : "/images/products/earings/1.JPG",
//         "description": "Dazzling sapphire drop earrings in a white gold setting."
//       },
//       {
//         "id": 2,
//         "name": "Art Deco Diamonds Earrings, L Model",
//         "material": "Rose Gold, Diamonds",
//          "img" : "/images/products/earings/2.JPG",
//         "description": "Chic hoop earrings with a touch of rose gold elegance."
//       },
//       {
//         "id": 3,
//         "name": "Art Deco Diamonds Earrings, L Model",
//         "material": "White Gold, Diamonds",
//          "img" : "/images/products/earings/3.JPG",
//         "description": "Chic hoop earrings with a touch of rose gold elegance."
//       },
     
//     ]
//   },
//   {
//     "category": "Rings",
//     "items": [
//       {
//         "id": 1,
//         "name": "Art Deco Diamonds Open Ring",
//         "material": "Rose Gold, Diamonds",
//          "img" : "/images/products/ring/1.JPG",
//         "description": "Exquisite diamond engagement ring in a platinum band."
//       },
//       {
//         "id": 2,
//         "name": "Art Deco Diamonds Open Ring",
//         "material": "White Gold, Diamonds",
//         "img" : "/images/products/ring/2.JPG",
//         "description": "Vibrant gemstone cocktail ring with a yellow gold setting."
//       },
//       {
//         "id": 3,
//         "name": "Art Deco Diamonds Ring",
//         "material": "Rose Gold, Diamonds",
//         "img" : "/images/products/ring/3.JPG",
//         "description": "Vibrant gemstone cocktail ring with a yellow gold setting."
//       },
//       {
//         "id": 4,
//         "name": "Art Deco Green Open Ring",
//         "material": "White Gold, Diamonds, Green Stone",
//          "img" : "/images/products/ring/4.JPG",
//         "description": "Vibrant gemstone cocktail ring with a yellow gold setting."
//       },
     
//     ]
//   },
//   {
//     "category": "Pendants",
//     "items": [
//       {
//         "id": 1,
//         "name": "Art Deco Diamonds Pendant, S Model",
//         "material": "Rose Gold, Diamonds",
//          "img" : "/images/products/pendents/1.JPG",
//         "description": "Sentimental heart-shaped locket made of sterling silver."
//       },
//       {
//         "id": 2,
//         "name": "Art Deco Diamonds Pendant, S Model",
//         "material": "White Gold, Diamonds",
//          "img" : "/images/products/pendents/2.JPG",
//         "description": "Elegant cross pendant crafted in white gold."
//       },
     
     
//     ]
//   },
//   {
//     "category": "Bangles",
//     "items": [
//       {
//         "id": 1,
//         "name": "Art Deco Green Bangle",
//         "material": "White Gold, Diamonds, Green Stone",
//          "img" : "/images/products/bangles/1.JPG",
//         "description": "Set of three silver bangles for a stylish look."
//       },
//       {
//         "id": 2,
//         "name": "Art Deco Mother Of Pearl Bangle",
//         "material": "Gold Plated",
//         "img" : "/images/products/bangles/2.JPG",
//         "description": "Trendy gold plated bangles for a touch of glamour."
//       },
//       {
//         "id": 3,
//         "name": "Art Deco Pink Coral Bangle",
//         "material": "Rose Gold, Diamonds, Coral",
//         "img" : "/images/products/bangles/3.JPG",
//         "description": "Trendy gold plated bangles for a touch of glamour."
//       },
      
//     ]
//   }
// ]


export const jewellerydata = [
  {
    "category": "Necklaces",
    "items": [
      {
        "id": 1,
        "name": "Art Deco Coral Necklace",
        "material": "Rose gold, Diamonds, Coral",
        "img" : "https://bijouq.com/wp-content/uploads/2023/06/IMG_1426-copy-2.mwpng_-300x300.png",
        "description": "Simple and elegant gold chain necklace."
      },
      {
        "id": 2,
        "name": "Art Deco Diamonds Necklace, L Model",
        "material": "Silver",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/IMG_0992-copy-300x300.png",
        "description": "Graceful necklace featuring a pearl pendant on a silver chain."
      },
      {
        "id": 3,
        "name": "Art Deco Diamonds Necklace, L Model",
        "material": "White Gold, Diamonds",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/IMG_0992.2png-300x300.png",
        "description": "Graceful necklace featuring a pearl pendant on a silver chain."
      },
      {
        "id": 4,
        "name": "Art Deco Diamonds Necklace, L Model",
        "material": "White Gold, Diamonds, Green Stone",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/46-1-300x300.jpg",
        "description": "Graceful necklace featuring a pearl pendant on a silver chain."
      },
      {
        "id": 5,
        "name": "Art Deco Diamonds Necklace, L Model",
        "material": "Yellow Gold, Diamonds, Green Stone",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/45-300x300.jpg",
        "description": "Graceful necklace featuring a pearl pendant on a silver chain."
      },
      {
        "id": 6,
        "name": "Art Deco Diamonds Necklace, L Model",
        "material": "White Gold, Diamonds, Green Stone",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/46-1-300x300.jpg",
        "description": "Graceful necklace featuring a pearl pendant on a silver chain."
      },
      {
        "id": 7,
        "name": "Art Deco Malachite Necklace",
        "material": "Rose gold, Diamonds, Malachite",
        "img": "https://bijouq.com/wp-content/uploads/2023/06/IMG_1426-copy-2-300x300.png",
        "description": "Graceful necklace featuring a pearl pendant on a silver chain."
      },
      {
        "id": 8,
        "name": "Art Deco Turquoise Necklace",
        "material": "White Gold, Diamonds, Turquoise",
        "img": "https://bijouq.com/wp-content/uploads/2023/06/IMG_1426-copy-w-300x300.png",
        "description": "Graceful necklace featuring a pearl pendant on a silver chain."
      },
      {
        "id": 9,
        "name": "Art Deco Pink Coral Necklace, L Model",
        "material": "White Gold, Diamonds, Green Stone",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/48-300x300.jpg",
        "description": "Graceful necklace featuring a pearl pendant on a silver chain."
      },
      {
        "id": 10,
        "name": "Classic Geomatrica Malachite Necklace, L Model",
        "material": "Rose Gold, Diamonds, Malachite",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/IMG_0997-copy-300x300.png",
        "description": "Graceful necklace featuring a pearl pendant on a silver chain."
      }
    ]
  },
  {
    "category": "Earrings",
    "items": [
      {
        "id": 1,
        "name": "Art Deco Coral Earrings",
        "material": "Rose gold, Diamonds, Coral",
        "img": "https://bijouq.com/wp-content/uploads/2023/06/IMG_1438-copyfwewef-2-600x600.png",
        "description": "Dazzling sapphire drop earrings in a white gold setting."
      },
      {
        "id": 2,
        "name": "Art Deco Diamonds Earrings, L Model",
        "material": "Rose Gold, Diamonds",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/IMG_1002-copy-600x600.png",
        "description": "Chic hoop earrings with a touch of rose gold elegance."
      },
      {
        "id": 3,
        "name": "Art Deco Diamonds Earrings, L Model",
        "material": "White Gold, Diamonds",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/IMG_1002-copy2-600x600.png",
        "description": "Chic hoop earrings with a touch of rose gold elegance."
      },
      {
        "id": 4,
        "name": "Art Deco Diamonds Earrings, S Model",
        "material": "Rose Gold, Diamonds",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/IMG_0181-copy-2-600x600.jpg",
        "description": "Chic hoop earrings with a touch of rose gold elegance."
      },
      {
        "id": 5,
        "name": "Art Deco Diamonds Hoop Earrings",
        "material": "Rose Gold, Diamonds",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/IMG_1011-copy-600x600.png",
        "description": "Chic hoop earrings with a touch of rose gold elegance."
      },
      {
        "id": 6,
        "name": "Art Deco Green Earrings, L Model",
        "material": "White Gold, Diamonds, Green Stone",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/39-600x600.jpg",
        "description": "Chic hoop earrings with a touch of rose gold elegance."
      },
      {
        "id": 7,
        "name": "Art Deco Green Earrings, S Model",
        "material": "White Gold, Diamonds, Green Stone",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/sgaegar-600x600.png",
        "description": "Chic hoop earrings with a touch of rose gold elegance."
      },
      {
        "id": 8,
        "name": "Art Deco Malachite Earrings",
        "material": "Rose gold, Diamonds, Malachite",
        "img": "https://bijouq.com/wp-content/uploads/2023/06/IMG_1438-copy-2-600x600.png",
        "description": "Chic hoop earrings with a touch of rose gold elegance."
      }
    ]
  },
  {
    "category": "Rings",
    "items": [
      {
        "id": 1,
        "name": "Art Deco Diamonds Open Ring",
        "material": "Rose Gold, Diamonds",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/IMG_1226-copy-600x600.png",
        "description": "Exquisite diamond engagement ring in a platinum band."
      },
      {
        "id": 2,
        "name": "Art Deco Diamonds Open Ring",
        "material": "White Gold, Diamonds",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/IMG_12262-600x600.png",
        "description": "Vibrant gemstone cocktail ring with a yellow gold setting."
      },
      {
        "id": 3,
        "name": "Art Deco Diamonds Ring",
        "material": "Rose Gold, Diamonds",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/IMG_1084-copy-600x600.png",
        "description": "Vibrant gemstone cocktail ring with a yellow gold setting."
      },
      {
        "id": 4,
        "name": "Art Deco Green Open Ring",
        "material": "White Gold, Diamonds, Green Stone",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/dacd-600x600.png",
        "description": "Vibrant gemstone cocktail ring with a yellow gold setting."
      },
      {
        "id": 5,
        "name": "Art Deco Green Ring",
        "material": "White Gold, Diamonds, Green Stone",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/TG-600x600.jpg",
        "description": "Vibrant gemstone cocktail ring with a yellow gold setting."
      },
      {
        "id": 6,
        "name": "Art Deco Pink Coral Open Ring",
        "material": "Rose Gold, Diamonds, Coral",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/frwwer-600x600.png",
        "description": "Vibrant gemstone cocktail ring with a yellow gold setting."
      },
      {
        "id": 6,
        "name": "Art Deco Pink Coral Ring",
        "material": "Rose Gold, Diamonds, Coral",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/IMG_6651W-600x600.jpg",
        "description": "Vibrant gemstone cocktail ring with a yellow gold setting."
      }
    ]
  },
  {
    "category": "Pendants",
    "items": [
      {
        "id": 1,
        "name": "Art Deco Diamonds Pendant, S Model",
        "material": "Rose Gold, Diamonds",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/fwar-copy-600x600.png",
        "description": "Sentimental heart-shaped locket made of sterling silver."
      },
      {
        "id": 2,
        "name": "Art Deco Diamonds Pendant, S Model",
        "material": "White Gold, Diamonds",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/fwar-copy.2png-600x600.png",
        "description": "Elegant cross pendant crafted in white gold."
      },
      {
        "id": 3,
        "name": "Art Deco Diamonds Pendant, S Model",
        "material": "White Gold, Diamonds, Green Stone",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/rfaer-600x600.png",
        "description": "Elegant cross pendant crafted in white gold."
      },
      {
        "id": 4,
        "name": "Art Deco Diamonds Pendant, S Model",
        "material": "White Gold, Diamonds, Green Stone",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/rfaer-600x600.png",
        "description": "Elegant cross pendant crafted in white gold."
      },
      {
        "id": 5,
        "name": "Classic Geomatrica Malachite Pendant, S Model",
        "material": "Rose Gold, Diamonds, Malachite",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/17-copy-600x600.jpg",
        "description": "Elegant cross pendant crafted in white gold."
      },
      {
        "id": 6,
        "name": "Art Deco Turquoise Pendant, S Model",
        "material": "White Gold, Diamonds, Turquoise",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/rawav-600x600.png",
        "description": "Elegant cross pendant crafted in white gold."
      },
      {
        "id": 7,
        "name": "Classic Geomatrica Pink Sapphire Pendant, S Model",
        "material": "Rose gold, Diamonds, Mother of pearl, Pink sapphire",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/20-600x600.jpg",
        "description": "Elegant cross pendant crafted in white gold."
      },
      {
        "id": 8,
        "name": "Coccopelli Diamonds Pendant, S Model",
        "material": "Rose Gold, Diamonds",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/small-5-600x600.png",
        "description": "Elegant cross pendant crafted in white gold."
      },
      {
        "id": 9,
        "name": "Coccopelli Diamonds Pendant, S Model",
        "material": "White Gold, Diamonds",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/small-3-600x600.png",
        "description": "Elegant cross pendant crafted in white gold."
      },
      {
        "id": 10,
        "name": "Coccopelli Diamonds Pendant, S Model",
        "material": "White Gold, Diamonds",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/s4-600x600.png",
        "description": "Elegant cross pendant crafted in white gold."
      },
     
    ]
  },
  {
    "category": "Bangles",
    "items": [
      {
        "id": 1,
        "name": "Art Deco Green Bangle",
        "material": "White Gold, Diamonds, Green Stone",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/IMG_0218-copy-300x300.png",
        "description": "Set of three silver bangles for a stylish look."
      },
      {
        "id": 2,
        "name": "Art Deco Mother Of Pearl Bangle",
        "material": "Gold Plated",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/IMG_0198-copy-300x300.png",
        "description": "Trendy gold plated bangles for a touch of glamour."
      },
      {
        "id": 3,
        "name": "Art Deco Pink Coral Bangle",
        "material": "Rose Gold, Diamonds, Coral",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/ERS-300x300.png",
        "description": "Trendy gold plated bangles for a touch of glamour."
      },
      {
        "id": 4,
        "name": "Art Deco Pink Coral Bangle",
        "material": "Rose Gold, Diamonds, Coral",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/IMG_02181-300x300.png",
        "description": "Trendy gold plated bangles for a touch of glamour."
      },
      {
        "id": 5,
        "name": "Classic Geomatrica Malachite Bangle",
        "material": "Rose gold, Diamonds, Malachite",
        "img": "https://bijouq.com/wp-content/uploads/2023/06/thshr-copy-300x300.jpg",
        "description": "Trendy gold plated bangles for a touch of glamour."
      },
      {
        "id": 6,
        "name": "Rose Malachite Open Bangle",
        "material": "Rose gold, Diamonds, Malachite",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/rwfe-copy-300x300.png",
        "description": "Trendy gold plated bangles for a touch of glamour."
      },
      {
        "id": 7,
        "name": "Rose Pink Coral Open Bangle",
        "material": "Rose Gold, Diamonds, Pink Coral",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/IMG_0240-copy-300x300.png",
        "description": "Trendy gold plated bangles for a touch of glamour."
      },
      {
        "id": 8,
        "name": "Rose Turquoise Open Bangle",
        "material": "Yellow Gold, Diamonds, Turquoise, Ruby",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/bangle-tur-300x300.png",
        "description": "Trendy gold plated bangles for a touch of glamour."
      },
    ]
  },
  {
    "category": "Bracelets",
    "items": [
      {
        "id": 1,
        "name": "ART DECO DIAMONDS Bracelet",
        "material": "Rose Gold, Diamonds",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/IMG_1151-copy-300x300.png",
        "description": "Casual and chic leather wrap bracelet for everyday wear."
      },
      {
        "id": 2,
        "name": "ART DECO DIAMONDS Bracelet",
        "material": "White Gold, Diamonds",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/IMG_11512-300x300.png",
        "description": "Sparkling crystal tennis bracelet with a rhodium finish."
      },
      {
        "id": 3,
        "name": "ART DECO DIAMONDS Bracelet",
        "material": "White Gold, Diamonds",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/51-300x300.jpg",
        "description": "Sparkling crystal tennis bracelet with a rhodium finish."
      },
      {
        "id": 4,
        "name": "ART DECO DIAMONDS Bracelet",
        "material": "Rose Gold, Diamonds, Coral",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/IMG_6776-300x300.jpg",
        "description": "Sparkling crystal tennis bracelet with a rhodium finish."
      },
      {
        "id": 5,
        "name": "ART DECO DIAMONDS Bracelet",
        "material": "Rose Gold, Diamonds, Malachite",
        "img": "https://bijouq.com/wp-content/uploads/2023/05/IMG_1509-copy-300x300.png",
        "description": "Sparkling crystal tennis bracelet with a rhodium finish."
      },
      {
        "id": 6,
        "name": "Flora Geomatrica Bracelet, 5 Motif",
        "material": "Rose Gold, Diamonds, Mother of Pearl",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/IMG_0588-copy-300x300.png",
        "description": "Sparkling crystal tennis bracelet with a rhodium finish."
      },
      {
        "id": 7,
        "name": "Rose Emerald Open Bracelet",
        "material": "Yellow Gold, Diamonds, Mother of Pearl, Emerald",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/IMG_02401-300x300.png",
        "description": "Sparkling crystal tennis bracelet with a rhodium finish."
      },
      {
        "id": 8,
        "name": "Palmyra Red Carnelian Bracelet",
        "material": "Rose Gold, Diamonds, Red Carnelian",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/IMG_6023-300x300.jpg",
        "description": "Sparkling crystal tennis bracelet with a rhodium finish."
      },
      {
        "id": 9,
        "name": "Palmyra Green Agate Bracelet",
        "material": "Yellow Gold, Diamonds, Green Agate",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/IMG_6040-300x300.jpg",
        "description": "Sparkling crystal tennis bracelet with a rhodium finish."
      },
      {
        "id": 10,
        "name": "Palmyra Pink Opal Bracelet",
        "material": "Rose Gold, Diamonds, Pink Opal",
        "img": "https://bijouq.com/wp-content/uploads/2022/10/bracelets-300x300.png",
        "description": "Sparkling crystal tennis bracelet with a rhodium finish."
      },
    ]
  }
]
